/**
 * Quantity Input Widget - handles +/- buttons and validation for quantity inputs
 */
export const initQuantityInputs = () => {
    const quantityWrappers = document.querySelectorAll('.quantity-input-wrapper');

    quantityWrappers.forEach(wrapper => {
        const input = wrapper.querySelector('.quantity-input');
        const plusBtn = wrapper.querySelector('.quantity-plus');
        const minusBtn = wrapper.querySelector('.quantity-minus');

        if (!input || !plusBtn || !minusBtn) return;

        // Get configuration from data attributes
        const step = parseFloat(wrapper.dataset.step) || 1;
        const minQty = parseFloat(wrapper.dataset.minQty) || 1;

        // Set initial input attributes
        input.setAttribute('min', minQty);
        input.setAttribute('step', step);

        // Plus button handler
        plusBtn.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default link behavior
            let currentValue = parseFloat(input.value) || 0;
            input.value = currentValue + step;

            // Trigger change event
            input.dispatchEvent(new Event('change'));
        });

        // Minus button handler
        minusBtn.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default link behavior
            let currentValue = parseFloat(input.value) || 0;
            let newValue = currentValue - step;
            if(newValue < 0) {
                newValue = 0;
            }

            input.value = newValue;

            // Trigger change event
            input.dispatchEvent(new Event('change'));
        });

        input.addEventListener('blur', (e) => {
            e.value = parseFloat(input.value) || 0;
            if(input.value < 0) {
                input.value = 0;
            }

            input.dispatchEvent(new Event('change'));
        })
    });
};

/**
 * Reinitialize quantity inputs (useful after AJAX form updates)
 */
export const reinitQuantityInputs = () => {
    initQuantityInputs();
};
